import axios from 'axios'
import vm from '@/main'
import store from '@/store/store'

export const client = axios.create({ baseURL: process.env.VUE_APP_SERVER_URL })

client.interceptors.request.use(async config => {
  const token = (vm.$shopify && (await vm.$shopify.getSessionToken())) || null
  config.headers.Authorization = `Bearer ${token}`
  return config
})

client.interceptors.response.use(null, error => {
  const { message } = error.response.data
  if (message === 'PlanAuthorizationError') vm.$notify({ text: 'Upgrade to premium', theme: 'purple', icon: require('@/assets/img/lock.svg') })
  if (message === 'ShopifyAuthorizationError') {
    const authUrl = `${process.env.VUE_APP_SERVER_URL}/auth?shop=${store.state.shopOrigin}`
    vm.$shopify.redirectToExternalUrl(authUrl)
  }
})
